export default __webpack_public_path__ + "static/media/traffic-full-web.97ead75d.jpg";